export default __webpack_public_path__ + "static/media/Pattern6.5f6c8898.png";